import { useMutation } from '@tanstack/react-query';

import { logError } from 'lib/sentry/logError';
import { useMutationHTTPRequest } from 'shared_DEPRECATED/hooks';

import { showErrorToast } from 'shared/components/Toast';

type TUseEditSprintTitleMutation = {
  options?: any;
};

type UseEditSprintTitleMutationProps = {
  title: string;
  sprintId: string;
  outcomes?: string;
};

export const useEditSprintTitleMutation = ({
  options,
}: TUseEditSprintTitleMutation) => {
  const { request } = useMutationHTTPRequest();

  return useMutation(
    ({ title, sprintId, outcomes }: UseEditSprintTitleMutationProps) =>
      request({
        url: `/api/sprints/${sprintId}/title`,
        body: { title, outcomes },
      }),
    {
      ...options,
      onError: (error) => {
        options?.onError?.(error);

        showErrorToast(
          "There's an error with editing the sprint title. Please try again later."
        );
        logError(error);
      },
    }
  );
};

export const useEditSprintTitleWithOutcomesMutation = ({
  sprintId,
  options,
}: TUseEditSprintTitleMutation & { sprintId: string }) => {
  const { request } = useMutationHTTPRequest();

  return useMutation(
    ({ title, outcomes }: UseEditSprintTitleMutationProps) =>
      request({
        url: `/api/sprints/${sprintId}/title`,
        body: { title, outcomes },
      }),
    {
      ...options,
      onError: (error) => {
        options?.onError?.(error);

        showErrorToast(
          "There's an error with editing the sprint title. Please try again later."
        );
        logError(error);
      },
    }
  );
};
